import React from 'react';
import Icon from '../../../components/AppIcon';

const PricePackageCard = ({ packageData, isPopular }) => {
    return (
        <div className={`relative p-4 md:p-6 rounded-xl border-2 transition-all ${isPopular
                ? 'border-primary bg-primary/5' : 'border-border bg-card'
            }`}>
            {isPopular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-primary text-primary-foreground text-xs font-medium">
                    Most Popular
                </div>
            )}
            <div className="flex items-start justify-between mb-4">
                <div>
                    <h4 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-1">
                        {packageData?.name}
                    </h4>
                    <p className="text-sm text-muted-foreground">{packageData?.duration}</p>
                </div>
                <div className="text-right">
                    <div className="text-2xl md:text-3xl font-data font-bold text-primary">
                        ${packageData?.price?.toLocaleString()}
                    </div>
                    <p className="text-xs text-muted-foreground mt-1">Starting from</p>
                </div>
            </div>
            <ul className="space-y-3 mb-4">
                {packageData?.features?.map((feature, index) => (
                    <li key={index} className="flex items-start gap-2">
                        <Icon
                            name={feature?.included ? "Check" : "X"}
                            size={18}
                            className={feature?.included ? "text-success mt-0.5" : "text-muted-foreground mt-0.5"}
                            strokeWidth={2.5}
                        />
                        <span className={`text-sm ${feature?.included ? 'text-foreground' : 'text-muted-foreground line-through'}`}>
                            {feature?.text}
                        </span>
                    </li>
                ))}
            </ul>
            {packageData?.note && (
                <div className="flex items-start gap-2 p-3 rounded-lg bg-muted/50 border border-border">
                    <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                    <p className="text-xs text-muted-foreground">{packageData?.note}</p>
                </div>
            )}
        </div>
    );
};

export default PricePackageCard;